import { render, staticRenderFns } from "./MsgPage.vue?vue&type=template&id=d1da9a42&scoped=true&"
import script from "./MsgPage.vue?vue&type=script&lang=js&"
export * from "./MsgPage.vue?vue&type=script&lang=js&"
import style0 from "./MsgPage.vue?vue&type=style&index=0&id=d1da9a42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1da9a42",
  null
  
)

export default component.exports